/* InboxConstants.js */

export const INBOX_CATEGORIES = [
    { name: 'Announcements', color: '#2563eb' },
    { name: 'Assignments', color: '#10b981' },
    { name: 'Queries', color: '#f59e0b' },
    { name: 'Alerts', color: '#ef4444' }
];

export const AI_TEMPLATES = [
    { 
        id: 'PERFORMANCE_APPRECIATION', 
        title: 'Performance Appreciation', 
        intent: 'PERFORMANCE_APPRECIATION',
        subject: 'Outstanding Academic Performance Appreciation',
        body: 'Dear Student/Parent,\n\nWe are delighted to acknowledge the outstanding academic performance recently demonstrated. Your hard work and dedication to your studies have truly paid off, and we encourage you to maintain this excellent momentum throughout the academic year.\n\nKeep up the great work!'
    },
    { 
        id: 'ASSIGNMENT_REMINDER', 
        title: 'Assignment Reminder', 
        intent: 'ASSIGNMENT_REMINDER',
        subject: 'Important: Upcoming Assignment Submission Deadline',
        body: 'Dear Students,\n\nThis is a friendly reminder regarding the upcoming assignment submission deadline for your current module. Please ensure that all components are completed and submitted via the portal by the specified date. Late submissions may be subject to institutional grading policies.\n\nIf you have any questions, please reach out to your faculty lead.'
    },
    { 
        id: 'EVENT_PARTICIPATION', 
        title: 'Event Participation', 
        intent: 'EVENT_PARTICIPATION',
        subject: 'Invitation: Upcoming School Event Participation',
        body: 'Dear Students and Parents,\n\nWe are excited to announce our upcoming school event and would love for you to participate! These events are a vital part of our community and provide fantastic opportunities for student growth and school spirit.\n\nPlease check the attached details for event dates and registration information.'
    },
    { 
        id: 'EXAM_SCHEDULE', 
        title: 'Exam Schedule', 
        intent: 'EXAM_SCHEDULE',
        subject: 'Official Notice: Upcoming Examination Schedule',
        body: 'Dear Students and Parents,\n\nThe official examination schedule for the upcoming term has been finalized and is now available for review. Please take note of the dates, timings, and venues for each subject.\n\nWe wish all our students the very best in their preparations.'
    },
    { 
        id: 'HOLIDAY_ANNOUNCEMENT', 
        title: 'Holiday Announcement', 
        intent: 'HOLIDAY_ANNOUNCEMENT',
        subject: 'Notification: Upcoming School Holiday',
        body: 'Dear Students and Parents,\n\nPlease be informed that the school will remain closed on [Date] in observance of [Occasion]. Normal classes will resume on [Resume Date].\n\nWishing you a restful and happy holiday break.'
    },
    { 
        id: 'FEE_REMINDER', 
        title: 'Fee Reminder', 
        intent: 'FEE_REMINDER',
        subject: 'Gentle Reminder: Tuition Fee Payment Due',
        body: 'Dear Parent,\n\nThis is a gentle reminder that the tuition fees for the current academic session are now due. Timely payment helps us maintain our high standard of educational facilities and services.\n\nIf you have already made the payment, please disregard this message.'
    },
    { 
        id: 'ATTENDANCE_ALERT', 
        title: 'Attendance Alert', 
        intent: 'ATTENDANCE_ALERT',
        subject: 'Notice: Low Attendance Alert',
        body: 'Dear Parent,\n\nWe are writing to bring to your attention that the current attendance record for [Student Name] has fallen below the required institutional minimum. Regular attendance is crucial for academic success and comprehensive learning.\n\nWe request you to look into this matter and ensure consistent attendance moving forward.'
    }
];

export const USER_TYPE_COLORS = {
    FACULTY: '#6366f1',
    STAFF: '#10b981',
    STUDENT: '#f59e0b',
    ADMIN: '#ef4444',
    SYSTEM: '#475569'
};
